module.exports = __webpack_public_path__ + "img/s1-5.913a3d9f.jpg";